import React, { Component } from 'react';

class ReportPage extends Component {

    render() {
        return (
            <div>
                <div className="container-mt-7 report-main-container">
                     
                </div>
            </div>
        )
    }

}

export default ReportPage;
